import { buildQuery } from "../../../../features/reduxworkbook/utils/buildQuery";

const checkForQuickTableArrayOptions = (quickArray, allowedoptions, key) => {
  return quickArray.reduce(
    (acc, obj, index) => {
      console.log(allowedoptions);

      if (key === "measure") {
        if (allowedoptions.includes(obj["measure"]["value"])) {
          acc.found = true; // Set the flag to true
          acc.indexes.push(index); // Push the matching index
        }
      } else if (key === "quickOption") {
        if (allowedoptions.includes(obj.quickOption)) {
          acc.found = true; // Set the flag to true
          acc.indexes.push(index); // Push the matching index
        }
      }
      return acc;
    },
    { found: false, indexes: [] }
  );
};

function checkColumnsForAvgOrDistinct(arr) {
  const indexes = [];

  arr.forEach((item, index) => {
    // Step 2: Create a space-separated array from the column value
    const spaceSeparated = item.column.split(" ");

    // Step 3: Check if the first part of the space-separated array is 'Total'
    if (spaceSeparated[0] === "Total") {
      // Step 4: Split the last item of the space-separated array by underscore
      const underscoreSeparated =
        spaceSeparated[spaceSeparated.length - 1].split("_");

      // Step 5: Check if the first part of the underscore-separated array is 'AVG' or 'DISTINCT'
      if (
        underscoreSeparated[0] === "AVG" ||
        underscoreSeparated[0] === "DISTINCT"
      ) {
        indexes.push(index);
      }
    }
  });

  // Step 6: If at least one match was found, return true and the indexes
  if (indexes.length > 0) {
    return { found: true, indexes };
  }

  // Return false if no matches were found
  return { found: false, indexes: [] };
}

const checkExternalTotalRequired = ({
  valueKeys,
  quickTableArray,
  sortProperties,
  isRowTotalVisible,
  isColumnTotalVisible,
  Data,
  dataSourceID,
  rawRowKeys,
  rawGroupByKeys,
  Sheetid,
  filters,
  commonFilters,
}) => {
  let grandTotalRequired,
    columnTotalRequired,
    rowTotalRequired = false;
  let rowTotalQuery,
    columnTotalQuery,
    grandTotalQuery = null;

  console.log(valueKeys);
  // check if column Totals are required

  //check for quick Table links with Column Total
  const columnTotalsRequiredCalculations = ["percentageOfColumnTotal"];
  const quickTableForColumn = checkForQuickTableArrayOptions(
    quickTableArray,
    columnTotalsRequiredCalculations,
    "quickOption"
  );
  const {
    found: requireColumnTotalForQuickTable,
    indexes: quickIndexesForColumnTotal,
  } = quickTableForColumn;

  const weNeedColumnTotals =
    requireColumnTotalForQuickTable || isColumnTotalVisible;

  //check if we need to fetch

  //check for length
  const fetchForLength = Data.length > 999;

  //check for measure
  const measuresForBackendTotals = ["AVG", "DISTINCT"];
  const measuresForColumn = checkForQuickTableArrayOptions(
    valueKeys,
    measuresForBackendTotals,
    "measure"
  );
  const { found: needTotalForValues, indexes: valueIndexesForTotal } =
    measuresForColumn;

  const needToFetchColumnTotal = needTotalForValues || fetchForLength;
  columnTotalRequired = needToFetchColumnTotal && weNeedColumnTotals;

  if (columnTotalRequired) {
    const columnTotalQueryInput = {
      rows: rawGroupByKeys,
      valueColumns: valueKeys,
      filters,
    };
    const { queryBody } = buildQuery(
      columnTotalQueryInput,
      dataSourceID,
      commonFilters
    );
    columnTotalQuery = queryBody;
  }

  //check for rowTotals

  //check if we need RowTotals

  //check for quick Table links with Column Total
  const rowTotalsRequiredCalculations = ["percentageOfRowTotal"];
  const quickTableForRow = checkForQuickTableArrayOptions(
    quickTableArray,
    rowTotalsRequiredCalculations,
    "quickOption"
  );
  const {
    found: requireRowTotalForQuickTable,
    indexes: quickIndexesForRowTotal,
  } = quickTableForRow;

  //check for Sort properties
  const checkForSort = checkColumnsForAvgOrDistinct(sortProperties);
  const { found: requireRowTotalForSort, indexes: sortIndexesForRowTotal } =
    checkForSort;

  const weNeedRowTotals =
    requireRowTotalForQuickTable || isRowTotalVisible || requireRowTotalForSort;

  //check if we need to fetch row Totals

  const weNeedToFetchRowTotals = requireRowTotalForSort || needTotalForValues;

  rowTotalRequired = weNeedToFetchRowTotals && weNeedRowTotals;
  // rowTotalRequired = weNeedToFetchRowTotals //will always fetch row totals if required for values to avoid bigger loops in pivotose data

  if (rowTotalRequired) {
    const rowTotalQueryInput = {
      rows: rawRowKeys,
      valueColumns: valueKeys,
      filters,
    };
    const { queryBody } = buildQuery(
      rowTotalQueryInput,
      dataSourceID,
      commonFilters
    );
    rowTotalQuery = queryBody;
  }

  //checkFor grandTotal

  //do we need grand totals
  const grandTotalsRequiredCalculations = ["percentageOfGrandTotal"];
  const quickTableForGrand = checkForQuickTableArrayOptions(
    quickTableArray,
    grandTotalsRequiredCalculations,
    "quickOption"
  );
  const {
    found: requireGrandTotalForQuickTable,
    indexes: quickIndexesForGrandTotal,
  } = quickTableForGrand;

  const bothTotalsVisible = isColumnTotalVisible && isRowTotalVisible;
  const weNeedGrandTotals = requireGrandTotalForQuickTable || bothTotalsVisible;

  //we will need to fetch based on measure values, hence no additional ode required

  grandTotalRequired = weNeedGrandTotals && needTotalForValues;

  if (grandTotalRequired) {
    const grandTotalQueryInput = { valueColumns: valueKeys, filters };
    const { queryBody } = buildQuery(
      grandTotalQueryInput,
      dataSourceID,
      commonFilters
    );
    grandTotalQuery = queryBody;
  }

  return {
    grandTotalRequired,
    columnTotalRequired,
    rowTotalRequired,
    rowTotalQuery,
    columnTotalQuery,
    grandTotalQuery,
  };
};

export { checkExternalTotalRequired };
